import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import moment from 'moment';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import Pagination from '~/components/pagination';
import TableList from '~/components/tableList';
import { TitleCategory } from '~/views/Consult/User/Detail/styles';

import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import { IListColCampaing } from '../model';

import { icons } from '~/assets';
import Container from '~/components/container';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import { IDefaultReturn } from '~/utils/masks';

import Input, { MaskTypes } from '~/components/input';
import * as St from '../style';
import CampaingData, { IFormCampaingData } from './components/campaingData';
import InfoDetailsCampaing from './components/InfoDetailsCampaing';
import {
  buildCustomerList,
  buildManualInsertList,
  customerHeader,
  customerHeaderManual,
} from './models/campaingModels';
import {
  ICustomer,
  IResponseCustomerDataPaginated,
  IResponseDetailsCampaing,
  IResponseDownloadCSV,
} from './models/interfaceModels';
import {
  getDetailsCampaing,
  handleRemoveSelected,
  handleUpdateCampaingBasicData,
  onClickCancelCampaing,
  onClickDownloadCSV,
  onClickIncludeCustomerManually,
  searchClientList,
  searchClientListManual,
} from './services/campaingService';
import ViewMockPushMobile from './components/viewMockPushMobile';

interface IResponseCustomerData {
  cpf: string;
  nomeCompleto: string;
  celular: string;
  numeroCartao: string;
  email: string;
  bairro: string;
  uf: string;
  cidade: string;
  statusCartao: string;
  nivel: string;
  limiteDisponivel: number;
  insertedManually?: boolean;
}

const PreviewCommunication: React.FC = () => {
  const history = useHistory();
  const { state } = useLocation<{
    idCampaing: string;
    nameCampaing: string;
    statusCampaing: string;
  }>();
  const [list, setList] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState<any[]>([]);
  const [listInsertManual, setListInsertManual] = useState<IListColCampaing[]>(
    [],
  );
  const [listInsertManualBackup, setListInsertManualBackup] = useState<
    IResponseCustomerData[]
  >([]);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialogPreviewIsOpen, setDialogPreviewIsOpen] = useState(false);
  const [infoDialog, setInfoDialog] = useState({
    open: false,
    message: '',
    error: false,
    isGoBack: false,
  });
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState<null | number>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPagesCustomerManual, setTotalPagesCustomerManual] = useState(0);
  const [totalItemsCustomerManual, setTotalItemsCustomerManual] = useState<
    null | number
  >(null);
  const [currentPageCustomerManual, setCurrentPageCustomerManual] = useState(1);
  const [downloadCVSProgress, setDownloadCVSProgress] = useState('');
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenDialogRemove, setIsOpenDialogRemove] = useState(false);
  const [form, setForm] = useState<IFormCampaingData>({
    descCampanha: state?.nameCampaing || '',
    dtaValidade: '',
    dtaInicio: moment(new Date()).format('DD/MM/YYYY'),
    horaInicio: moment(new Date()).format('HH:mm'),
    horaValidade: '',
    switchDtaExecucao: false,
  });
  const [
    dataInfoCampaing,
    setDataInfoCampaing,
  ] = useState<IResponseDetailsCampaing>({} as IResponseDetailsCampaing);
  const [cpf, setCpf] = useState({} as IDefaultReturn);
  const [nome, setNome] = useState('');

  const GETDetailsCampaing = useApi<IResponseDetailsCampaing>(
    Endpoints.fidelizacao.getDetailsCampaign.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.GET,
  );

  const GETGainsCustomers = useApi<ICustomer>(
    `${Endpoints.fidelizacao.getGainsCustomers
      .replace('PARAM_ID_CAMPANHA', state?.idCampaing)
      .replace('PARAM_LIMITE_PAGE', '10')
      .replace('PARAM_PAGE', currentPage.toString())}`,
    ApiMethod.GET,
  );

  const GETDownloadGainsCustomers = useApi<IResponseDownloadCSV>(
    Endpoints.fidelizacao.getDownloadGainsCustomers.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.GET,
  );

  const DELETECancelCampaing = useApi(
    `${Endpoints.fidelizacao.deleteCampaign.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    )}`,
    ApiMethod.DELETE,
  );

  const GETBuscaClientesCampanha = useApi<IResponseCustomerDataPaginated>(
    Endpoints.boxBaseClients.getBuscaClientesCampanhaPaginada
      .replace('PARAM_CPF', cpf.unmasked || '')
      .replace('PARAM_NOME', nome || '')
      .replace('PARAM_LIMITE_PAGE', '4')
      .replace('PARAM_PAGE', currentPageCustomerManual.toString()),
    ApiMethod.GET,
  );

  const POSTIncludeCustomersManually = useApi(
    Endpoints.fidelizacao.postIncludeCustomersManually.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.POST,
  );

  const POSTRemoveCustomerManually = useApi(
    Endpoints.fidelizacao.postRemoveCustomerManually.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.POST,
  );

  const POSTUpdateCampaingBasicData = useApi(
    Endpoints.fidelizacao.postUpdateCampaignBasicData.replace(
      'PARAM_ID_CAMPANHA',
      state?.idCampaing,
    ),
    ApiMethod.POST,
  );

  /**
   * Atualiza a lista de clientes inseridos manualmente,
   * alterando o ícone e removendo a ação do cliente que foi inserido.
   * @param item Dados do cliente.
   * @param data Lista completa de clientes.
   */
  const handleListUpdate = (
    item: IResponseCustomerData,
    data: IResponseCustomerData[],
  ) => {
    data.forEach((customer, index) => {
      if (customer.cpf === item.cpf) {
        data[index].insertedManually = true;
      }
    });
    // setListInsertManualBackup(data);
    setListInsertManual([]);
    setCurrentPageCustomerManual(1);
    onClickIncludeCustomerManually(
      item,
      POSTIncludeCustomersManually,
      handleListUpdateRemove,
      setInfoDialog,
    );
    buildManualInsertList(data, setListInsertManual, goToInsert);
  };

  /**
   * Atualiza a lista de clientes inseridos manualmente,
   * removendo o cliente que ja foi inserido ou que ja estava inserido na campanha,
   * para evitar que o usuario tente inserir mais de uma vez o mesmo cliente.
   * @param item Dados do cliente.
   */
  const handleListUpdateRemove = (item: IResponseCustomerData) => {
    const newList = listInsertManual.filter((i) => i[7].item.cpf !== item.cpf);
    setListInsertManual(newList);
    const newListBackup = listInsertManualBackup.filter(
      (i) => i.cpf !== item.cpf,
    );
    setListInsertManualBackup(newListBackup);
  };

  /**
   * Navega para a tela de inserir cliente manualmente.
   * @param a Evento de clique.
   * @param item Dados do cliente.
   */
  const goToInsert = (
    a?: any,
    item?: IResponseCustomerData,
    data?: IResponseCustomerData[],
    list?: IListColCampaing[],
  ) => {
    handleListUpdate(item, data);
  };

  /**
   * Verifica se algum dos serviços retornou erro.
   * @returns true quando tem algum problema em algum serviço chamado.
   */
  const checkSuccess = () => {
    if (
      GETGainsCustomers.error ||
      GETGainsCustomers.status === 404 ||
      GETGainsCustomers.status === 500 ||
      DELETECancelCampaing.error ||
      DELETECancelCampaing.status === 404 ||
      DELETECancelCampaing.status === 500 ||
      list.length === 0
    ) {
      return true;
    }

    return false;
  };

  /**
   * Verifica se o usuario tem permissao para ver as opcoes de salvar e cancelar campanha.
   * @returns true quando o usuario tiver permissao e a campanha for de status preview.
   */
  const { hasRole } = useUserRole();

  const showOptionsRule = () =>
    hasRole('ADM') && GETDetailsCampaing.data?.status === 'PREVIEW';

  useEffect(() => {
    if (state?.idCampaing) {
      searchClientList(
        GETGainsCustomers,
        setInfoDialog,
        setTotalPages,
        setTotalItems,
      ).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          buildCustomerList(response.data, setList);
        }
      });
      getDetailsCampaing(
        GETDetailsCampaing,
        setForm,
        setInfoDialog,
        setDataInfoCampaing,
      );
    }
  }, [state]);

  useEffect(() => {
    if (currentPage > 1) {
      searchClientList(
        GETGainsCustomers,
        setInfoDialog,
        setTotalPages,
        setTotalItems,
      ).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          buildCustomerList(response.data, setList);
        }
      });
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentPageCustomerManual >= 1 && GETBuscaClientesCampanha.success) {
      searchClientListManual(
        state?.idCampaing,
        GETBuscaClientesCampanha,
        setInfoDialog,
        setTotalPagesCustomerManual,
        setTotalItemsCustomerManual,
      ).then((response) => {
        if (response) {
          buildManualInsertList(response, setListInsertManual, goToInsert);
        }
      });
    }
  }, [currentPageCustomerManual]);

  useEffect(() => {
    if (totalItems !== null) {
      setDataInfoCampaing({
        ...dataInfoCampaing,
        totalAtingidos: totalItems || 0,
      });
    }
  }, [totalItems]);

  return (
    <>
      <Loading
        status={
          GETGainsCustomers.loading ||
          DELETECancelCampaing.loading ||
          GETDownloadGainsCustomers.loading ||
          GETBuscaClientesCampanha.loading ||
          POSTIncludeCustomersManually.loading ||
          POSTUpdateCampaingBasicData.loading ||
          POSTRemoveCustomerManually.loading ||
          GETDetailsCampaing.loading
        }
        text={downloadCVSProgress}
      />
      <Dialog
        widthInPercent={70}
        open={dialogPreviewIsOpen}
        positiveLabel="Concluir"
        positiveAction={() => {
          setDialogPreviewIsOpen(false);
        }}
        icon={icons.check}
        title="Visualização da push notification"
      >
        <ContainerFlex center horizontal>
          <ViewMockPushMobile
            title={dataInfoCampaing?.templateMensagem?.titulo}
            text={dataInfoCampaing?.templateMensagem?.mensagem}
          />
        </ContainerFlex>
      </Dialog>
      <Dialog
        widthInPercent={70}
        open={dialogIsOpen}
        positiveLabel="Concluir"
        Loading={
          GETBuscaClientesCampanha.loading ||
          POSTIncludeCustomersManually.loading
        }
        positiveAction={() => {
          setDialogIsOpen(false);
          setListInsertManual([]);
          setListInsertManualBackup([]);
          searchClientList(
            GETGainsCustomers,
            setInfoDialog,
            setTotalPages,
            setTotalItems,
          ).then((response) => {
            if (response.status >= 200 && response.status < 300) {
              buildCustomerList(response.data, setList);
            }
          });
        }}
        icon={icons.check}
        title="Inserir cliente manualmente"
      >
        <ContainerFlex row wrap>
          <ContainerFlex marginRight={10} maxWidth={35}>
            <Input
              label="CPF"
              value={cpf.masked}
              onChange={(e) => setCpf(e.target.value)}
              placeholder="000.000.000-00"
              maxLength={14}
              mask={MaskTypes.CPF}
            />
          </ContainerFlex>
          <ContainerFlex maxWidth={35}>
            <Input
              id="nome"
              name="nome"
              type="text"
              label="Nome"
              maxLength={14}
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </ContainerFlex>
          <ContainerFlex marginLeft={10} maxWidth={10}>
            <Button
              borderRadius={10}
              style={{ marginLeft: '10%' }}
              fitContent
              onClick={() => {
                setTotalPagesCustomerManual(0);
                setTotalItemsCustomerManual(0);
                setCurrentPageCustomerManual(1);
                if (
                  !GETBuscaClientesCampanha.success ||
                  currentPageCustomerManual === 1
                ) {
                  searchClientListManual(
                    state?.idCampaing,
                    GETBuscaClientesCampanha,
                    setInfoDialog,
                    setTotalPagesCustomerManual,
                    setTotalItemsCustomerManual,
                  ).then((response) => {
                    if (response) {
                      buildManualInsertList(
                        response,
                        setListInsertManual,
                        goToInsert,
                      );
                    }
                  });
                }
              }}
              disabled={!cpf.masked && !nome}
            >
              <span>Consultar</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>

        {listInsertManual.length > 0 && (
          <ContainerFlex marginTop={20}>
            <TableList
              customerHeader={customerHeaderManual}
              list={listInsertManual}
            />
            {totalPagesCustomerManual > 1 && (
              <ContainerFlex row horizontal center marginTop={20}>
                <Pagination
                  totalPages={totalPagesCustomerManual}
                  onCurrentPageChange={(page) => {
                    setCurrentPageCustomerManual(page);
                  }}
                />
              </ContainerFlex>
            )}
          </ContainerFlex>
        )}
      </Dialog>
      <Dialog
        icon={infoDialog.error ? icons.exclamation : icons.check}
        open={infoDialog?.open}
        title="Detalhes"
        widthInPercent={40}
        positiveLabel="Entendi"
        positiveAction={() => {
          setInfoDialog({
            message: '',
            open: false,
            error: false,
            isGoBack: false,
          });
          if (infoDialog.isGoBack) {
            history.push('/campanha');
          }
        }}
        message={infoDialog?.message}
      />
      <Dialog
        icon={icons.exclamation}
        open={isOpenDialog}
        positiveLabel="Sim"
        negativeLabel="Não"
        positiveAction={async () => {
          setIsOpenDialog(false);
          await onClickCancelCampaing(DELETECancelCampaing, setInfoDialog);
          getDetailsCampaing(
            GETDetailsCampaing,
            setForm,
            setDataInfoCampaing,
            setInfoDialog,
          );
        }}
        negativeAction={() => setIsOpenDialog(false)}
        message={'Deseja realmente cancelar a campanha?'}
      />
      <Dialog
        icon={icons.exclamation}
        open={isOpenDialogRemove}
        positiveLabel="Sim"
        negativeLabel="Não"
        positiveAction={() => {
          setIsOpenDialogRemove(false);
          handleRemoveSelected(
            selectedCustomers,
            POSTRemoveCustomerManually,
            setInfoDialog,
          ).then((response) => {
            if (response && response.status >= 200 && response.status < 300) {
              // Atualiza a lista de clientes atingidos pela campanha após a remoção
              searchClientList(
                GETGainsCustomers,
                setInfoDialog,
                setTotalPages,
                setTotalItems,
              ).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                  buildCustomerList(response.data, setList);
                }
              });
            }
          });
        }}
        negativeAction={() => setIsOpenDialogRemove(false)}
        message={'Deseja realmente excluir estes clientes da campanha?'}
      />

      <Container>
        <St.BoxCard>
          <St.Title>Detalhes da campanha</St.Title>
          <ContainerFlex>
            <CampaingData
              form={form}
              setForm={setForm}
              isPreview
              isBtnSave={dataInfoCampaing?.status !== 'FINALIZADA'}
              onClickBtnSave={(forms) => {
                handleUpdateCampaingBasicData(
                  POSTUpdateCampaingBasicData,
                  setInfoDialog,
                  forms,
                ).then((response) => {
                  if (response.status >= 200 && response.status < 300) {
                    setInfoDialog({
                      open: true,
                      message: 'Dados da campanha atualizados com sucesso!',
                      error: false,
                      isGoBack: false,
                    });
                    getDetailsCampaing(
                      GETDetailsCampaing,
                      setForm,
                      setDataInfoCampaing,
                      setInfoDialog,
                    );
                  }
                });
              }}
            />

            <ContainerFlex row wrap>
              <ContainerFlex>
                <ContainerFlex marginBottom={10}>
                  {list.length > 0 && (
                    <>
                      <ContainerFlex row center space-between marginBottom={30}>
                        <InfoDetailsCampaing data={dataInfoCampaing} />

                        <ContainerFlex row end>
                          <Button
                            borderRadius={10}
                            fitContent
                            onClick={() => {
                              onClickDownloadCSV(
                                GETDownloadGainsCustomers,
                                setDownloadCVSProgress,
                                setInfoDialog,
                              );
                            }}
                          >
                            <span>Download</span>
                          </Button>
                          <Button
                            borderRadius={10}
                            fitContent
                            marginLeft={10}
                            onClick={() => {
                              history.push('/campanha');
                            }}
                          >
                            <span>Voltar</span>
                          </Button>
                        </ContainerFlex>
                      </ContainerFlex>

                      <TableList
                        customerHeader={customerHeader}
                        list={list}
                        checkbox={showOptionsRule()}
                        onSubmitSelectedRows={(rows: any[]) =>
                          setSelectedCustomers(rows)
                        }
                      />

                      {totalPages > 1 && (
                        <ContainerFlex row horizontal center marginTop={20}>
                          <Pagination
                            totalPages={totalPages}
                            onCurrentPageChange={(page) => {
                              setCurrentPage(page);
                            }}
                          />
                        </ContainerFlex>
                      )}

                      <ContainerFlex row end marginTop={20}>
                        <Button
                          borderRadius={10}
                          fitContent
                          onClick={() => setDialogPreviewIsOpen(true)}
                          disabled={!dataInfoCampaing?.templateMensagem}
                        >
                          <span>Visualizar</span>
                        </Button>
                        <Button
                          borderRadius={10}
                          marginLeft={10}
                          fitContent
                          onClick={() => setDialogIsOpen(true)}
                          disabled={!showOptionsRule()}
                        >
                          <span>Incluir</span>
                        </Button>
                        <Button
                          borderRadius={10}
                          fitContent
                          marginLeft={10}
                          onClick={() => {
                            if (
                              !selectedCustomers ||
                              selectedCustomers.length === 0
                            )
                              setInfoDialog({
                                open: true,
                                message:
                                  'Selecione ao menos um cliente para remover da campanha.',
                                error: false,
                                isGoBack: false,
                              });
                            setIsOpenDialogRemove(true);
                          }}
                          disabled={
                            selectedCustomers.length === 0 || !showOptionsRule()
                          }
                        >
                          <span>Remover</span>
                        </Button>
                        <Button
                          borderRadius={10}
                          fitContent
                          marginLeft={10}
                          onClick={() => {
                            setIsOpenDialog(true);
                          }}
                          disabled={!showOptionsRule()}
                        >
                          <span>Cancelar</span>
                        </Button>
                        <Button
                          borderRadius={10}
                          fitContent
                          marginLeft={10}
                          onClick={() =>
                            history.push('/define-communication-actions', {
                              idCampaing: state?.idCampaing,
                              dataCampaing: GETDetailsCampaing.data,
                              templateMensagem:
                                GETDetailsCampaing.data?.templateMensagem,
                            })
                          }
                          disabled={!showOptionsRule()}
                        >
                          <span>Avançar</span>
                        </Button>
                      </ContainerFlex>
                    </>
                  )}
                  {checkSuccess() && (
                    <ContainerFlex center marginTop={30}>
                      <TitleCategory>Nenhum resultado encontrado</TitleCategory>
                    </ContainerFlex>
                  )}
                </ContainerFlex>
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default PreviewCommunication;
